let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9EI97")).then(() => parcelRequire('ivpO0'));